export default "__VITE_ASSET__b3bc54ce__"